import React, { useEffect, useState } from "react";
import { ChevronRight } from "lucide-react";
import { VideoThumb } from "./VideoThumb";
import { supabase } from "../../supabaseClient";
import { NOT_HELD } from "../constants/collections";

// Horizontal scrollable row of recently published drills. Titled "New drills"
// so "drop" only ever means the Wednesday Drop.
// Anchors the dashboard's "what's new" pulse.
export function ThisWeeksDrops({ C, dark, onOpen, go, narrow = false }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      // Pull the 10 most recent published drills from the last 14 days.
      const since = new Date(Date.now() - 14 * 86400000).toISOString();
      const { data } = await supabase
        .from("drills")
        .select("id, title, category, mux_playback_id, section, created_at")
        .or("status.eq.published,status.is.null")
        // Held drills are recent by definition right after a batch upload,
        // so without this the rail is the fastest way to leak a whole shelf.
        .or(NOT_HELD)
        .neq("section", "sets")
        .gte("created_at", since)
        .order("created_at", { ascending: false })
        .limit(10);
      if (cancelled) return;
      setItems(data || []);
      setLoading(false);
    })();
    return () => { cancelled = true; };
  }, []);

  if (loading || items.length === 0) return null;

  // Said the way every other section on the home page says it: Bebas, a
  // hairline, the way through on the right. No NEW on each card: the
  // header already says they're this week's.
  return (
    <div>
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:14}}>
        <span style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:narrow ? 22 : 26,letterSpacing:1.4,color:C.text,lineHeight:1}}>New drills</span>
        <div style={{flex:1,height:1,background:C.border}}/>
        <button onClick={()=>go && go("pd")}
          className="btn-inline"
          style={{background:"transparent",border:"none",cursor:"pointer",color:C.textMid,fontSize:11,fontWeight:700,letterSpacing:.6,textTransform:"uppercase",display:"inline-flex",alignItems:"center",gap:3,padding:0,minHeight:32}}>
          All <ChevronRight size={12}/>
        </button>
      </div>
      <div className="bam-rail" style={{display:"flex",gap:12,overflowX:"auto",WebkitOverflowScrolling:"touch",paddingBottom:4,
        scrollSnapType:"x mandatory",scrollbarWidth:"none",...(narrow ? {marginRight:-16,paddingRight:16} : {})}}>
        {items.map(d => {
          const daysAgo = Math.max(0, Math.floor((Date.now() - new Date(d.created_at).getTime()) / 86400000));
          return (
            <div key={d.id} onClick={()=>onOpen && onOpen(d)}
              className="btn bam-thumb-card"
              style={{flex:`0 0 ${narrow ? 250 : 220}px`,scrollSnapAlign:"start",cursor:"pointer",borderRadius:12,overflow:"hidden",background:C.cardGradient,border:`1px solid ${C.cardBorder}`}}>
              <div style={{position:"relative",aspectRatio:"16/9",background:"#000"}}>
                <VideoThumb playbackId={d.mux_playback_id} width={480} height={270} dim/>
                <div style={{position:"absolute",inset:0,background:"linear-gradient(transparent 45%, rgba(0,0,0,0.7))"}}/>
                <div style={{position:"absolute",bottom:7,left:8,right:8,fontSize:12,fontWeight:700,color:"#fff",lineHeight:1.25,display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",overflow:"hidden",textShadow:"0 1px 4px rgba(0,0,0,0.6)",wordBreak:"break-word"}}>{d.title}</div>
              </div>
              <div style={{padding:"8px 10px",fontSize:11,color:C.textMid,display:"flex",justifyContent:"space-between",alignItems:"center",gap:8}}>
                <span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{d.category || "General"}</span>
                <span style={{flexShrink:0}}>{daysAgo === 0 ? "Today" : daysAgo === 1 ? "Yesterday" : `${daysAgo}d ago`}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ThisWeeksDrops;
